// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useMemo, useState } from "react";
import { MDBContainer, MDBInput, MDBRow } from "mdbreact";

const CertificatesList = ({
  blockedUser,
  checkBlockedUser,
  certificates,
  handlerCheck,
  checkGroup,
  userGroup,
  userWorkedBefore,
  checkWorkedWithBefore
}) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows(Array.from({ length: Math.ceil(certificates.length / 4) }, (_, index) => index))
  }, [certificates.length])

  const sortedCertificates = useMemo(() => {
    return rows.map((_, rowIndex) => {
      return certificates.slice(rowIndex * 4, rowIndex * 4 + 4);
    });
  }, [rows, certificates]);

  return (
    <>
      <ul className="check_list">
        {certificates.map((certificate, index) => (

          <li className="active" key={certificate._id}>
            <div className="check_block">
              <label className="check_btn">
                <input type="checkbox"
                  id={certificate._id}
                  label={certificate.name}
                  name={certificate.name}
                  value={certificate._id}
                  onChange={handlerCheck}
                />
                {certificate.name}
              </label>
            </div>
          </li>
        ))}
        <li className="active">
          <div className="check_block">
            <label className="check_btn">
              <input type="checkbox"
                id={"group"}
                name={'preferedGroups'}
                value={userGroup}
                onChange={checkGroup}
              />
              Preferred Groups
            </label>
          </div>
        </li>
        <li className="active">
          <div className="check_block">
            <label className="check_btn">
              <input type="checkbox"
                id={"workedBefore"}
                label={"Worked With Before"}
                name={'workedBefore'}
                value={userWorkedBefore}
                onChange={checkWorkedWithBefore}
              />
              Worked With Before
            </label>
          </div>
        </li>
        <li className="active" >
          <div className="check_block">
            <label className="check_btn">
              <input type="checkbox"
                 id={"blocked"}
                 name={'blockedContractors'}
                 value={blockedUser}
                 onChange={checkBlockedUser}
              />
              Blocked Contractors
            </label>
          </div>
        </li>
      </ul>
    </>
  )
}

export default CertificatesList;
